var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("LimitedAccessBanner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.limitedAccess || _vm.showAttestation,
            expression: "limitedAccess || showAttestation",
          },
        ],
        attrs: { rows: _vm.feedsRow, attestationMessage: _vm.showAttestation },
      }),
      _vm._v(" "),
      _c("mds-empty-state", {
        staticClass: "saved-feed__response-message",
        attrs: {
          title: _vm.translate(_vm.title),
          message: _vm.translate(_vm.description),
        },
        scopedSlots: _vm._u([
          {
            key: "mds-empty-state-icon",
            fn: function () {
              return [
                _c("mds-inline-message", {
                  staticClass: "saved-feed__check-mark",
                  attrs: { variation: "success", "icon-only": "" },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "mds-empty-state-actions",
            fn: function () {
              return [
                _c("p", {
                  staticClass: "saved-feed__3rd-party-message",
                  domProps: {
                    textContent: _vm._s(
                      _vm.translate("scheduler.modal.3rdparty.description")
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "mds-button",
                  {
                    staticClass: "saved-feed__close-button",
                    attrs: { variation: "secondary" },
                    on: { click: _vm.onClick },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translate(
                            "scheduler.modal.save.success.ok.button"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.requestFromLens
                  ? _c(
                      "mds-button",
                      {
                        staticClass: "saved-feed__redirect-button",
                        attrs: {
                          variation: "primary",
                          disabled: _vm.isRedirecting,
                          loading: _vm.isRedirecting,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.redirectToDetails.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.translate(
                                "scheduler.modal.save.success.redirect.button"
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }